import React, { useMemo, useState, useEffect } from "react";
import { useTable, useFilters, useSortBy, usePagination  } from "react-table";
import axios from "axios";
import {Link} from 'react-router-dom';
import Spinner from './Spinner';
import "./TestTableStyle.css"

function Table({ columns, data }) {
    
  const [filterInput, setFilterInput] = useState("");

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setFilter,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 12 },
    },
    useFilters,
    useSortBy,
    usePagination
  );

  const handleFilterChange = e => {
    const value = e.target.value || undefined;
    setFilter("itemname", value);
    setFilterInput(value);
  };

  return (
    <>
    <br />
    <br />
    <br />
      <input
        value={filterInput}
        onChange={handleFilterChange}
        placeholder={"Search name"}
      />
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  className={
                    column.isSorted
                      ? column.isSortedDesc
                        ? "sort-desc"
                        : "sort-asc"
                      : ""
                  }
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return (
                    <td {...cell.getCellProps()}>
                      {cell.column.Header === 'View' ? <Link target="_blank" to={`/viewmyproduct/${cell.value}`}>{'View Product'}</Link> : cell.column.Header === 'Created' ? new Date(cell.value).toDateString() : cell.column.Header === 'Active' ? (cell.value).toString() : cell.render('Cell')}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {'<'}
        </button>{' '}
        <span>
          Page{' '}
            {pageIndex + 1} of {pageOptions.length}
        </span>
        {' '}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[12, 24, 48, 96].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
      </div>
    </>
  );
}

const SponItems = (props) => {

  const [loading, setLoading] = useState(true);
  const [sponuser, setUser] = useState(JSON.parse(localStorage.getItem('sponuser')) || []);
  const [items, setItems] = useState([]);
  const [data, setData] = useState([]);
  const [none, setNone] = useState(false);

  const fetcher = () => {
    try {
    axios.get(`${process.env.REACT_APP_API_URL}/b/sponitems/${sponuser.sponsorid}`)
    .then(res => {
        setItems(res.data);
        setData(res.data);
        setLoading(false);
    }) } catch (error){
        return
    }
}

useEffect(() => {
    fetcher();
}, [])

function noProducts() {
  return items === false;
}

  const columns = useMemo(
    () => [
      {
        Header: "Products",
        columns: [
          {
            Header: "View",
            accessor: "itemid"
          },
          {
            Header: "Name",
            accessor: "itemname"
          },
          {
            Header: "Created",
            accessor: "created_at"
          },
          {
            Header: "Category",
            accessor: "itemcategory"
          },
          {
            Header: "Price ($)",
            accessor: "value"
          },
          {
            Header: "Active",
            accessor: "listingactive"
          }
        ]
      }
    ],
    []
  );

  return (
    <div>
       {
        (loading) ? (<div>
          <br />
          <br />
          <br />
          <br />
           <Spinner />
           </div> ) : (     
    <div>
       <br />
      <br />
      <br />
      <br />
      { noProducts() ? (<div className="glass-chart">
        <h1>You have no Products here!</h1>
        </div>) :
      (
      <div className="glass-chart">
      <div className="App-tab">
      <Table columns={columns} data={data} />
      </div>
      </div>)}
    </div>)}
    
    </div>
  );
}

export default SponItems;